import { render } from "./CalificacionesColaborador.vue?vue&type=template&id=3e5dcd5c"
import script from "./CalificacionesColaborador.vue?vue&type=script&lang=js"
export * from "./CalificacionesColaborador.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__